import React, {Component} from 'react';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import AvailableLinksInput from "./AvailableLinksInput/AvailableLinksInput";
import InfoLinksInput from "./InfoLinksInput/InfoLinksInput";
import ReleasesInput from "./ReleasesInput/ReleasesInput";
import DevelopersInput from "./DevelopersInput/DevelopersInput";
import PublishersInput from "./PublishersInput/PublishersInput";
import GameTypesInput from "./GameTypesInput/GameTypesInput";
import PlatformsInput from "./PlatformsInput/PlatformsInput";
import apiUrl from "../../shared/config";
import TextAreaWithTabs from "../UI/TextAreaWithTabs/TextAreaWithTabs";
import VideoLinkInput from "./VideoLinkInput/VideoLinkInput";
import EmbedLinksInput from "./EmbedLinksInput/EmbedLinksInput";
import GameStyleInput from "../UI/GameStyleInput/GameStyleInput";
import SubmitButtonWarning from "../UI/SubmitButtonWarning/SubmitButtonWarning";

class NewGame extends Component {
    state = {
        "game_id": null,
        "game_name": "",
        "game_description": "",
        "game_image": "",
        "video_trailer": "",
        "video_gameplay": "",
        "game_available_links": [],
        "game_info_links": [],
        "game_developers": [],
        "game_platforms": [],
        "game_publishers": [],
        "game_types": [],
        "game_releases": [],
        "game_embed_links": {game_embed: [], itch_embed: []},
        "game_style": 1,
        "failMessage": "",
        "showFailMessage": false,
        "validVideos": [false, false],
    };


    componentDidMount() {
        this.setState({'user_id': this.props.userId})
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
        if (
            ((this.state.game_id === null && this.props.selectedGameId !== null) ||
            (this.props.selectedGameId !== null && this.state.game_id !== this.props.selectedGameId)) &&
            this.props.newGameOpen === true && this.props.selectedGameId !== undefined
        ) {
            axios.get(apiUrl +'Games/getGameById?game_id=' + this.props.selectedGameId)
                .then(response => {
                    this.setState(response.data);
                });
        } else if (prevState.game_id !== null && this.props.selectedGameId === null) {
            this.setState({
                "game_id": null,
                "game_name": "",
                "game_description": "",
                "game_image": "",
                "video_trailer": "",
                "video_gameplay": "",
                "game_available_links": [],
                "game_info_links": [],
                "game_developers": [],
                "game_platforms": [],
                "game_publishers": [],
                "game_types": [],
                "game_releases": [],
                "game_embed_links": {game_embed: [], itch_embed: []},
                "game_style": 1,
                "validVideos": [false, false],
            });
        }
    };

    validateEmbeds = () => {
        const allLinks = [...this.state.game_embed_links.itch_embed, ...this.state.game_embed_links.game_embed]
        let validatedEmbeds = true;
        for (const gameEmbedLinks of allLinks) {
            if (!gameEmbedLinks.valid) {
                validatedEmbeds = false;
                break;
            }
        }
        return validatedEmbeds;
    }

    validateVideos = () => {
        return !this.state.validVideos.includes(false);
    }

    addHandler = () => {
        if (this.validateEmbeds()) {
            this.postDataHandler(null);
            //this.props.cancelAddGame();
        }
    };

    updateHandler = () => {
        if (this.validateEmbeds() && this.validateVideos()) {
            this.postDataHandler(this.state.game_id);
            //this.props.cancelAddGame();
        }
    };

    availableLinksUpdateHandler = (new_value) => {
        this.setState({game_available_links: new_value});
    };

    infoLinksUpdateHandler = (new_value) => {
        this.setState({game_info_links: new_value});
    };

    releasesUpdateHandler = (new_value) => {
        this.setState({game_releases: new_value});
    };

    developersUpdateHandler = (new_value) => {
        this.setState({game_developers: new_value});
    };

    publishersUpdateHandler = (new_value) => {
        this.setState({game_publishers: new_value});
    };

    gameTypesUpdateHandler = (new_value) => {
        this.setState({game_types: new_value});
    };

    platformsUpdateHandler = (new_value) => {
        this.setState({game_platforms: new_value});
    };

    gameStyleUpdateHandler = (new_value) => {
        this.setState({game_style: new_value})
    }

    cancelHandler = () => {
        this.props.cancelAddGame();
    };

    embedLinksUpdateHandler = (new_value) => {
        this.setState({game_embed_links: new_value})
    }

    postDataHandler = (game_id) => {
        let message = '';
        const post = {
            "game_id": game_id,
            "user_id": this.props.userId,
            "game_name": this.state.game_name,
            "game_description":this.state.game_description,
            "game_image": (this.state.game_image ? this.state.game_image : ''),
            "video_trailer": (this.state.video_trailer ? this.state.video_trailer : ''),
            "video_gameplay": (this.state.video_gameplay ? this.state.video_gameplay : ''),
            "game_available_links": this.state.game_available_links,
            "game_info_links": this.state.game_info_links,
            "game_releases": this.state.game_releases,
            "game_developers": this.state.game_developers,
            "game_publishers": this.state.game_publishers,
            "game_types": this.state.game_types,
            "game_platforms": this.state.game_platforms,
            "game_embed_links": this.state.game_embed_links,
            "game_style": this.state.game_style,
        };

        axios.post(apiUrl +'Games/set?token=' + this.props.token, post)
            .then(response => {
                if (!response.data.message) {
                    this.props.addGame()
                } else {
                    message = response.data.message
                    this.setState({failMessage: response.data.message, showFailMessage: true})
                }
            }).then(() => {
                if (!message) {
        this.setState({
            "game_id": null,
            "user_id": this.props.userId,
            "game_name": "",
            "game_description": "",
            "game_image": "",
            "video_trailer": "",
            "video_gameplay": "",
            "game_available_links": [],
            "game_info_links": [],
            "game_developers": [],
            "game_platforms": [],
            "game_publishers": [],
            "game_types": [],
            "game_releases": [],
            "game_embed_links": {game_embed: [], itch_embed: []},
            "game_style": 1,
            "failMessage": "",
            "showFailMessage": false,
            "validVideos": [false, false]
        })}}).then(() => {
            if (!message) {
                this.props.cancelAddGame();
            }
        });
    };

    setShowFailMessage = (val) => {
        this.setState({showFailMessage: val})
    }

    setValidTrailer = (val) => {
        this.setState(prev => {
            return {validVideos: [val, prev.validVideos[1]]}
        })
    }

    setValidGameplay = (val) => {
        this.setState(prev => {
            return {validVideos: [prev.validVideos[0], val]}
        })
    }

    render () {
        if(!this.props.isAuthenticated && this.props.newGameOpen) {
            this.cancelHandler();
        }

        const valid = this.validateEmbeds() && this.validateVideos();
        const buttonStyles = valid ? {} : {backgroundColor: "darkgray", borderColor: "darkgray"};
        const disabledUpdateString = "*" +
            (!this.validateEmbeds() ? "invalid embed link" : "") +
            (!this.validateVideos() ? (this.validateEmbeds() ? "invalid video link" : ", invalid video link") : ""); // this feels dumb, write some sort of builder or something when we add more error messages.
        const disabledUpdateText = valid ?
            <div></div> :
            <div style={{color: "red", fontStyle: "italic"}}>{disabledUpdateString}</div>

        let addAndUpdateButton = (
            <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
            <SubmitButtonWarning
                token={this.props.token} userId={this.props.userId}
                handleSubmit={this.updateHandler}
                failMessage={this.state.failMessage}
                setShowFailMessage={this.setShowFailMessage}
                showFailMessage={this.state.showFailMessage}
                postType={{
                    lowercase: "games",
                    capital: "Game",
                    capitalLowercase: "Games",
                }}
                submitButton={
                    <Button style={buttonStyles} onClick={this.addHandler}>Add Game</Button>
                }/>
                {disabledUpdateText}
            </div>
        );
        let pageTitle = "Add a Game";
        if (this.state.game_id !== null) {
            addAndUpdateButton = (
                <div style={{display: "flex", alignItems: "center", gap: "10px"}}>
                <SubmitButtonWarning
                    token={this.props.token} userId={this.props.userId}
                    handleSubmit={this.updateHandler}
                    failMessage={this.state.failMessage}
                    setShowFailMessage={this.setShowFailMessage}
                    showFailMessage={this.state.showFailMessage}
                    postType={{
                        lowercase: "games",
                        capital: "Game",
                        capitalLowercase: "Games",
                    }}
                    submitButton={
                        <Button style={buttonStyles} onClick={this.updateHandler}>Update Game</Button>
                    }/>
                    {disabledUpdateText}
                </div>
            );

            pageTitle = "Editing: " + this.state.game_name;
        }
        const cancelButton = (<><Button variant="outline-warning" onClick={this.cancelHandler}>Cancel</Button></>);

        let new_game_return = '';
        if (this.props.newGameOpen) {
            new_game_return = (
                <div className="card new-game">
                    <h1 className="card-header">{pageTitle}</h1>
                    <div className="card-body">
                        <div className="card-text">
                            <Container>
                                <Row><Col><dl className="row">
                                    <dt className="col-sm-3"><label>Game Name</label></dt>
                                    <dd className="col-sm-9">
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter the full name of a game."
                                            value={this.state.game_name}
                                            onChange={(event) => this.setState({game_name: event.target.value})}
                                        />
                                    </dd>
                                </dl></Col></Row>
                                <Row><Col><dl className="row">
                                    <dt className="col-sm-3"><label>Game Description</label></dt>
                                    <dd className="col-sm-9">
                                        <TextAreaWithTabs
                                            rows="4"
                                            placeholder="Include a paragraph or so long description of the game."
                                            value={this.state.game_description}
                                            onChange={(event) => this.setState({game_description: event.target.value})}
                                        />
                                    </dd>
                                </dl></Col></Row>

                                <Row><Col><dl className="row">
                                    <dt className="col-sm-3"><label>Game Image</label></dt>
                                    <dd className="col-sm-9">
                                        <Form.Control
                                            type="text"
                                            placeholder="Enter a link to an image of the game. Respect Copyright."
                                            value={this.state.game_image}
                                            onChange={(event) => this.setState({game_image: event.target.value})}
                                        />
                                    </dd>
                                </dl></Col></Row>
                                <Row><Col>
                                    <dl className="row">
                                        <dt className="col-sm-3"><label>Game Style</label></dt>
                                        <dd className="col-sm-9" style={{marginTop: -30,}}> {/* This is a really stupid solution but I have no clue there the margin is coming from that is messing with this */}
                                            <GameStyleInput
                                                currentSelection={this.state.game_style}
                                                onUpdate={this.gameStyleUpdateHandler}
                                                useDefaultValue={false}
                                            />
                                        </dd>
                                    </dl>
                                </Col></Row>
                                <Row><Col>
                                    <EmbedLinksInput
                                        isGame={true}
                                        embedLinks={this.state.game_embed_links}
                                        embedLinksUpdate={this.embedLinksUpdateHandler}
                                    />
                                </Col></Row>
                                <Row><Col>
                                        <EmbedLinksInput
                                            embedLinks={this.state.game_embed_links}
                                            embedLinksUpdate={this.embedLinksUpdateHandler}
                                        />
                                </Col></Row>
                                <Row><Col><dl className="row">
                                    <dt className="col-sm-3"><label>Game Trailer</label></dt>
                                    <dd className="col-sm-9">
                                        <VideoLinkInput
                                            value={this.state.video_trailer}
                                            update={(event) => this.setState({video_trailer: event.target.value})}
                                            updateValid={this.setValidTrailer}
                                        />
                                    </dd>
                                </dl></Col></Row>
                                <Row><Col><dl className="row" style={{marginBottom: 0}}>
                                    <dt className="col-sm-3"><label>Gameplay Video</label></dt>
                                    <dd className="col-sm-9">
                                        <VideoLinkInput
                                            value={this.state.video_gameplay}
                                            update={(event) => this.setState({video_gameplay: event.target.value})}
                                            updateValid={this.setValidGameplay}
                                        />
                                    </dd>
                                </dl></Col></Row>

                                <Row>
                                    <Col>
                                        <AvailableLinksInput
                                            availableLinks={this.state.game_available_links}
                                            availableLinksUpdate={(val) => this.availableLinksUpdateHandler(val)}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <InfoLinksInput
                                            infoLinks={this.state.game_info_links}
                                            infoLinksUpdate={(val) => this.infoLinksUpdateHandler(val)}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <ReleasesInput
                                            gameReleases={this.state.game_releases}
                                            releasesUpdate={(val) => this.releasesUpdateHandler(val)}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <DevelopersInput
                                            gameDevelopers={this.state.game_developers}
                                            developersUpdate={(val) => this.developersUpdateHandler(val)}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <PublishersInput
                                            gamePublishers={this.state.game_publishers}
                                            publishersUpdate={(val) => this.publishersUpdateHandler(val)}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <GameTypesInput
                                            gameTypes={this.state.game_types}
                                            gameTypesUpdate={(val) => this.gameTypesUpdateHandler(val)}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <PlatformsInput
                                            gamePlatforms={this.state.game_platforms}
                                            platformsUpdate={(val) => this.platformsUpdateHandler(val)}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>{addAndUpdateButton}</Col>
                                    <Col>{cancelButton}</Col>
                                </Row>
                            </Container>
                        </div>
                    </div>
                </div>
            );
        }

        return new_game_return
    }
}

export default NewGame;